<template>
  <div id="paramc_common">
    <div id="prodcut_input_area">
      <div class="product_input_title">
        <h2>商品寸法をご入力ください。</h2>
      </div>
      <div id="reference_image">
        <ul class="ul_tab small_text bold">
          <li v-for="(inputRef, index) in targetPlan.inputReferenceList" :key="'inputRef-' + index"
            @click="tabType=inputRef.tabId" v-bind:class="{active: tabType==inputRef.tabId, tab_title: true}">{{inputRef.tabName}}</li>
        </ul>
        <div v-for="(inputRef, index) in targetPlan.inputReferenceList" :key="'inputRefImage-' + index">
          <div class="img_field" v-if="tabType==inputRef.tabId">
            <img :src="getImage('top/item/input/' + inputRef.img)" width="100%" height="100%">
          </div>
        </div>
      </div>
      <div class="product_input_size_area">
        <div class="product_input_size">
          <div class="size_title">W</div>
          <div class="size_comb">
            <template v-if="isDisableWidth"><div class="fixed_size">{{paramForm.width}}</div></template>
            <template v-else>
              <input type="text" v-model="paramForm.width" @keypress="validateNumber" @input="paramForm.width=inputRestNumber($event)" @blur="onBlurStorageItemW" @focus="selectedAll">
              <label class="small_text">{{paramForm.minWidth}}mm ～ {{paramForm.maxWidth}}mm</label>
            </template>
          </div>
        </div>
        <div class="product_input_size">
          <div class="size_title">H</div>
          <div class="size_comb">
            <template v-if="isDisableHeight"><div class="fixed_size">{{paramForm.height}}</div></template>
            <template v-else>
              <input type="text" v-model="paramForm.height" @keypress="validateNumber" @input="paramForm.height=inputRestNumber($event)" @blur="onBlurStorageItemH" @focus="selectedAll">
              <label class="small_text">{{paramForm.minHeight}}mm ～ {{paramForm.maxHeight}}mm</label>
            </template>
          </div>
        </div>
        <div class="product_input_size">
          <div class="size_title">D</div>
          <div class="size_comb">
            <template v-if="isDisableDepth"><div class="fixed_size">{{paramForm.depth}}</div></template>
            <template v-else>
              <input type="text" v-model="paramForm.depth" @keypress="validateNumber" @input="paramForm.depth=inputRestNumber($event)" @blur="onBlurStorageItemD" @focus="selectedAll">
              <label class="small_text">{{paramForm.minDepth}}mm ～ {{paramForm.maxDepth}}mm</label>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="errors_field">
      <div v-if="errors.width" class="error_text">{{errors.width}}</div>
      <div v-if="errors.height" class="error_text">{{errors.height}}</div>
      <div v-if="errors.depth" class="error_text">{{errors.depth}}</div>
    </div>
    <div id="product_input_filler">
      <div class="product_input_title">
        <h2>壁埋め込みの有無をご選択ください。</h2>
        <div class="space"></div>
      </div>
    </div>
    <div class="filler_input_size_area">
      <div class="filler_input_size">
        <div></div>
        <div>
          <div class="filler_input">
            <div class="radio">
              <input type="radio" id="l_wall1" name="left_filler" value=3 v-model.number="paramForm.fillerTypeLeft" @click="changerLeftFiller" :disabled="paramForm.fillerDisableLeft"/>
              <label for="l_wall1" class="radio-label">左壁側</label>
            </div>
            <div class="size_comb">
              <input type="text" :disabled="isLeftFiller===false"
                v-model="paramForm.fillerSizeLeft"
                @keypress="validateNumber"
                @input="paramForm.fillerSizeLeft=inputRestNumber($event)"
                v-bind:class="{warns_color: warns.fillerLeft}"
                @blur="onBlurFillerLeft"
                @focus="selectedAll">
              <div class="small_text">0mm ～ 300mm</div>
            </div>
          </div>
        </div>
        <div>
          <div class="filler_input">
            <div class="radio">
              <input type="radio" id="l_wall2" name="left_filler" value=0 v-model.number="paramForm.fillerTypeLeft" @click="changerLeftFiller"/>
              <label for="l_wall2" class="radio-label">なし</label>
            </div>
          </div>
          <div></div>
        </div>
      </div>
      <div class="filler_input_size">
        <div></div>
        <div>
          <div class="filler_input">
            <div class="radio">
              <input type="radio" id="r_wall1" name="right_filler" value=3 v-model.number="paramForm.fillerTypeRight" @click="changeRightFiller" :disabled="paramForm.fillerDisableRight"/>
              <label for="r_wall1" class="radio-label">右壁側</label>
            </div>
            <div class="size_comb">
              <input type="text" :disabled="isRightFiller===false"
                v-model="paramForm.fillerSizeRight"
                @keypress="validateNumber"
                @input="paramForm.fillerSizeRight=inputRestNumber($event)"
                v-bind:class="{warns_color: warns.fillerRight}"
                @blur="onBlurFillerRight"
                @focus="selectedAll">
              <div class="small_text">0mm ～ 300mm</div>
            </div>
          </div>
        </div>
        <div>
          <div class="filler_input">
            <div class="radio">
              <input type="radio" id="r_wall2" name="right_filler" value=0 v-model.number="paramForm.fillerTypeRight" @click="changeRightFiller"/>
              <label for="r_wall2" class="radio-label">なし</label>
            </div>
          </div>
          <div></div>
        </div>
      </div>
      <div class="filler_input_size">
        <div></div>
        <div>
          <div class="filler_input">
            <div class="radio">
              <input type="radio" id="u_wall1" name="top_filler" value=3 v-model.number="paramForm.fillerTypeCounter" @click="changeCounterFiller" :disabled="paramForm.fillerDisableCounter"/>
              <label for="u_wall1" class="radio-label">奥壁側</label>
            </div>
            <div class="size_comb">
              <input type="text" :disabled="isCenterFiller===false"
                v-model="paramForm.fillerSizeCounter"
                @keypress="validateNumber"
                @input="paramForm.fillerSizeCounter=inputRestNumber($event)"
                v-bind:class="{warns_color: warns.fillerCounter}"
                @blur="onBlurFillerCenter"
                @focus="selectedAll">
              <div class="small_text">0mm ～ 300mm</div>
            </div>
          </div>
        </div>
        <div>
          <div class="filler_input">
            <div class="radio">
              <input type="radio" id="u_wall2" name="top_filler" value=0 v-model.number="paramForm.fillerTypeCounter" @click="changeCounterFiller"/>
              <label for="u_wall2" class="radio-label">なし</label>
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </div>
    <div class="small_p pickup">壁埋め込みをされる場合「組立設置」をご選択いただくことはできません。</div>
    <div class="warns_field">
      <div v-if="warns.fillerLeft" class="error_text middle_text">{{warns.fillerLeft}}</div>
      <div v-if="warns.fillerRight" class="error_text middle_text">{{warns.fillerRight}}</div>
      <div v-if="warns.fillerCounter" class="error_text middle_text">{{warns.fillerCounter}}</div>
    </div>
  </div>
</template>
<script>
import * as Check from '../../../../../utils/Check'
import * as App from '../../../../../utils/App'
import * as FormUtil from '../../../../../utils/FormUtil'

const MIN_BURY_SIZE = 0
const MAX_BURY_SIZE = 300

export default {
  components: {
  },
  props: {
    targetPlan: Object,
    isDisableForm: Boolean,
    isExecOrder: Boolean
  },
  data () {
    return {
      paramForm: {
        width: '',
        height: '',
        height2: '',
        depth: '',
        depth2: '',
        minWidth: '',
        maxWidth: '',
        minHeight: '',
        maxHeight: '',
        minDepth: '',
        maxDepth: '',
        fillerSizeLeft: '',
        fillerSizeRight: '',
        fillerSizeCounter: '',
        fillerTypeLeft: 0,
        fillerTypeRight: 0,
        fillerTypeCounter: 0,
        fillerDisableLeft: false,
        fillerDisableRight: false,
        fillerDisableCounter: false
      },
      errors: {},
      warns: {},
      tabType: 1
    }
  },
  watch: {
    targetPlan: function (plan) {
      console.log('param size watch')
      this.paramForm.width = plan.dcWidth
      this.paramForm.height = plan.dcHeight
      this.paramForm.height2 = plan.dcHeight2
      this.paramForm.depth = plan.dcDepth
      this.paramForm.depth2 = plan.dcDepth2
      this.paramForm.minWidth = plan.dcMinWidth
      this.paramForm.maxWidth = plan.dcMaxWidth
      this.paramForm.minHeight = plan.dcMinHeight
      this.paramForm.maxHeight = plan.dcMaxHeight
      this.paramForm.minHeight2 = plan.dcMinHeight2
      this.paramForm.maxHeight2 = plan.dcMaxHeight2
      this.paramForm.minDepth = plan.dcMinDepth
      this.paramForm.maxDepth = plan.dcMaxDepth
      this.paramForm.minDepth2 = plan.dcMinDepth2
      this.paramForm.maxDepth2 = plan.dcMaxDepth2
      this.paramForm.fillerSizeLeft = plan.dcBSize
      this.paramForm.fillerSizeRight = plan.dcCSize
      this.paramForm.fillerSizeCounter = plan.dcDSize
      this.paramForm.fillerTypeLeft = plan.dcBType
      this.paramForm.fillerTypeRight = plan.dcCType
      this.paramForm.fillerTypeCounter = plan.dcDType
      this.paramForm.fillerDisableLeft = plan.dcBTypeDisableFlg
      this.paramForm.fillerDisableRight = plan.dcCTypeDisableFlg
      this.paramForm.fillerDisableCounter = plan.dcDTypeDisableFlg
    }
  },
  computed: {
    itemWidth: function () {
      let size = Number(this.paramForm.width)
      // マイナス値にはさせない
      if (size <= 0) {
        size = Number(0)
      }
      return size
    },
    itemHeight: function () {
      let size = Number(this.paramForm.height)
      // マイナス値にはさせない
      if (size <= 0) {
        size = Number(0)
      }
      return size
    },
    itemDepth: function () {
      let size = Number(this.paramForm.depth)
      // マイナス値にはさせない
      if (size <= 0) {
        size = Number(0)
      }
      return size
    },
    isDisableWidth: function () {
      return this.paramForm.minWidth === this.paramForm.maxWidth
    },
    isDisableHeight: function () {
      return this.paramForm.minHeight === this.paramForm.maxHeight
    },
    isDisableDepth: function () {
      return this.paramForm.minDepth === this.paramForm.maxDepth
    },
    isLeftFiller: function () {
      if (!this.paramForm.fillerTypeLeft) return false
      if (Number(this.paramForm.fillerTypeLeft) === 3) {
        return true
      }
      return false
    },
    isRightFiller: function () {
      if (!this.paramForm.fillerTypeRight) return false
      if (Number(this.paramForm.fillerTypeRight) === 3) {
        return true
      }
      return false
    },
    isCenterFiller: function () {
      if (!this.paramForm.fillerTypeCounter) return false
      if (Number(this.paramForm.fillerTypeCounter) === 3) {
        return true
      }
      return false
    },
    isEnableHeight2: function () {
      if (this.paramForm.minHeight2 === undefined && this.paramForm.maxHeight2 === undefined) return false
      if (this.paramForm.minHeight2 === 0 && this.paramForm.maxHeight2 === 0) return false
      return true
    }
  },
  methods: {
    getParam: function () {
      let param = {
        width: this.paramForm.width,
        height: this.paramForm.height,
        height2: this.isEnableHeight2 ? this.paramForm.height2 : undefined,
        depth: this.paramForm.depth,
        depth2: this.paramForm.depth2,
        minWidth: this.paramForm.minWidth,
        maxWidth: this.paramForm.maxWidth,
        minHeight: this.paramForm.minHeight,
        maxHeight: this.paramForm.maxHeight,
        minDepth: this.paramForm.minDepth,
        maxDepth: this.paramForm.maxDepth,
        fillerSizeLeft: this.paramForm.fillerSizeLeft,
        fillerSizeRight: this.paramForm.fillerSizeRight,
        fillerSizeCounter: this.paramForm.fillerSizeCounter,
        fillerTypeLeft: this.paramForm.fillerTypeLeft,
        fillerTypeRight: this.paramForm.fillerTypeRight,
        fillerTypeCounter: this.paramForm.fillerTypeCounter,
        fillerDisableLeft: this.paramForm.fillerDisableLeft,
        fillerDisableRight: this.paramForm.fillerDisableRight,
        fillerDisableCounter: this.paramForm.fillerDisableCounter
      }
      return param
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    changerLeftFiller: function (event) {
      if (Number(event.target.value) !== 0) {
        this.paramForm.fillerTypeLeft = Number(event.target.value)
      } else {
        this.paramForm.fillerTypeLeft = 0
        this.paramForm.fillerSizeLeft = 0
        delete this.warns.fillerLeft
      }
      this.changeWallFlag()
    },
    changeRightFiller: function (event) {
      if (Number(event.target.value) !== 0) {
        this.paramForm.fillerTypeRight = Number(event.target.value)
      } else {
        this.paramForm.fillerTypeRight = 0
        this.paramForm.fillerSizeRight = 0
        delete this.warns.fillerRight
      }
      this.changeWallFlag()
    },
    changeCounterFiller: function (event) {
      if (Number(event.target.value) !== 0) {
        this.paramForm.fillerTypeCounter = Number(event.target.value)
      } else {
        this.paramForm.fillerTypeCounter = 0
        this.paramForm.fillerSizeCounter = 0
        delete this.warns.fillerCounter
      }
      this.changeWallFlag()
    },
    onBlurFillerLeft: function () {
      this.paramForm.fillerSizeLeft = this.checkFillerLeft(Number(this.paramForm.fillerSizeLeft))
    },
    onBlurFillerRight: function () {
      this.paramForm.fillerSizeRight = this.checkFillerRight(Number(this.paramForm.fillerSizeRight))
    },
    onBlurFillerCenter: function () {
      this.paramForm.fillerSizeCounter = this.checkMaxFillerCounter(Number(this.paramForm.fillerSizeCounter))
    },
    onBlurStorageItemW: function () {
      if (!this.paramForm.width || this.paramForm.width <= 0) {
        this.paramForm.width = 0
      }
      // 計算後の値をチェックする。
      let ret = this.validateItemW()
      if (!ret) {
        return false
      }
    },
    onBlurStorageItemH: function () {
      if (!this.paramForm.height || this.paramForm.height <= 0) {
        this.paramForm.height = 0
      }
      // 計算前の値をチェックする
      let ret = this.validateItemH()
      if (!ret) {
        return false
      }
    },
    onBlurStorageItemD: function () {
      // 商品サイズ
      if (!this.paramForm.depth || this.paramForm.depth <= 0) {
        this.paramForm.depth = 0
      }
      let ret = this.validateItemD()
      if (!ret) {
        return false
      }
    },
    selectedAll: function (event) {
      event.target.select()
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      str = FormUtil.deleteTopZero(str)
      return str
    },
    checkParam: function () {
      let isCheckW = this.validateItemW()
      let isCheckH = this.validateItemH()
      let isCheckD = this.validateItemD()
      return isCheckW && isCheckH && isCheckD
    },
    validateItemW: function () {
      let ret = true
      // 商品サイズのチェック
      if (this.itemWidth < this.paramForm.minWidth) {
        this.errors['width'] = 'Wの商品サイズは最小商品寸法より大きい値になるようにご入力ください。'
        ret = false
      } else if (this.itemWidth > this.paramForm.maxWidth) {
        this.errors['width'] = 'Wの商品サイズは最大商品寸法より小さい値になるようにご入力ください。'
        ret = false
      }

      if (ret) {
        delete this.errors.width
      }
      this.$forceUpdate()
      return ret
    },
    validateItemH: function () {
      let ret = true
      if (this.itemHeight < this.paramForm.minHeight) {
        this.errors['height'] = 'Hの商品サイズは最小商品寸法より大きい値になるようにご入力ください。'
        ret = false
      } else if (this.itemHeight > this.paramForm.maxHeight) {
        this.errors['height'] = 'Hの商品サイズは最大商品寸法より小さい値になるようにご入力ください。'
        ret = false
      }
      if (ret) {
        delete this.errors.height
      }
      this.$forceUpdate()
      return ret
    },
    validateItemD: function () {
      let ret = true
      if (this.itemDepth < this.paramForm.minDepth) {
        this.errors['depth'] = 'Dの商品サイズは最小商品寸法より大きい値になるようにご入力ください。'
        ret = false
      } else if (this.itemDepth > this.paramForm.maxDepth) {
        this.errors['depth'] = 'Dの商品サイズは最大商品寸法より小さい値になるようにご入力ください。'
        ret = false
      }

      if (ret) {
        delete this.errors.depth
      }
      this.$forceUpdate()
      return ret
    },
    checkFillerLeft: function (size) {
      let retSize = 0
      if (size < MIN_BURY_SIZE) {
        this.warns['fillerLeft'] = '警告：左壁側の埋め込みの最小値は' + MIN_BURY_SIZE + 'mmです。'
        retSize = MIN_BURY_SIZE
      } else if (size > MAX_BURY_SIZE) {
        this.warns['fillerLeft'] = '警告：左壁側の埋め込みの最大値は' + MAX_BURY_SIZE + 'mmです。'
        retSize = MAX_BURY_SIZE
      } else {
        delete this.warns.fillerLeft
        retSize = size
      }
      this.$forceUpdate()
      return retSize
    },
    checkFillerRight: function (size) {
      let retSize = 0
      if (size < MIN_BURY_SIZE) {
        this.warns['fillerRight'] = '警告：右壁側の埋め込みの最小値は' + MIN_BURY_SIZE + 'mmです。'
        retSize = MIN_BURY_SIZE
      } else if (size > MAX_BURY_SIZE) {
        this.warns['fillerRight'] = '警告：右壁側の埋め込みの最大値は' + MAX_BURY_SIZE + 'mmです。'
        retSize = MAX_BURY_SIZE
      } else {
        delete this.warns.fillerRight
        retSize = size
      }
      this.$forceUpdate()
      return retSize
    },
    checkMaxFillerCounter: function (size) {
      let retSize = 15
      if (size < MIN_BURY_SIZE) {
        this.warns['fillerCounter'] = '警告：奥壁側の埋め込みの最小値は' + MIN_BURY_SIZE + 'mmです。'
        retSize = MIN_BURY_SIZE
      } else if (size > MAX_BURY_SIZE) {
        this.warns['fillerCounter'] = '警告：奥壁側の埋め込みの最大値は' + MAX_BURY_SIZE + 'mmです。'
        retSize = MAX_BURY_SIZE
      } else {
        delete this.warns.fillerCounter
        retSize = size
      }
      this.$forceUpdate()
      return retSize
    },
    changeWallFlag: function () {
      if (this.paramForm.fillerTypeLeft !== 0 || this.paramForm.fillerTypeRight !== 0 || this.paramForm.fillerTypeCounter !== 0) {
        this.$emit('changeWallFlag', true)
      } else {
        this.$emit('changeWallFlag', false)
      }
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  mounted: function () {
  }
}
</script>
<style src="../../../../css/dcstyle.scss" lang="scss" scoped></style>
<style src="../../../../css/dc-common.scss" lang="scss" scoped></style>
<style src="../../../../css/dc-customize.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/top/input/paramater/ParamSize.vue